import request from '../../utils/request'

export const getBasicInfo = (data: RequestData) => {
  return request('getBasicInfo', {
    method: 'post',
    data,
  })
}

export const getMapInfo = (data: RequestData) => {
  return request('getMapInfo', {
    method: 'post',
    data,
  })
}

export const getStatisticInfo = (data: RequestData) => {
  return request('getStatisticInfo', {
    method: 'post',
    data,
  })
}

export const getOrderAndBikeTrend = (data: RequestData) => {
  return request('getOrderAndBikeTrend', {
    method: 'post',
    data,
  })
}

export const getCityInfo = (data: RequestData) => {
  return request('getCityInfo', {
    method: 'post',
    data,
  })
}

export const getBikeInfo = (data: RequestData) => {
  return request('getBikeInfo', {
    method: 'post',
    data,
  })
}

export const getParkingPosition = (data: RequestData) => {
  return request('getParkingPosition', {
    method: 'post',
    data,
  })
}

export const getOperationPosition = (data: RequestData) => {
  return request('getOperationPosition', {
    method: 'post',
    data,
  })
}

export const getHeatMap = (data: RequestData) => {
  return request('getHeatMap', {
    method: 'post',
    data,
  })
}

export const getLatestOrder = (data: RequestData) => {
  return request('getLatestOrder', {
    method: 'post',
    data,
  })
}

export const getAreaInfo = (data: RequestData) => {
  return request('getAreaInfo', {
    method: 'post',
    data,
  })
}

export const getParkingPointAlarmList = (data: RequestData) => {
  return request('getParkingPointAlarmList', {
    method: 'post',
    data,
  })
}

export const getBikeLatestOrderList = (data: RequestData) => {
  return request('getBikeLatestOrderList', {
    method: 'post',
    data,
  })
}

export const getUserReserveWorkOrder = (data: RequestData) => {
  return request('getUserReserveWorkOrder', {
    method: 'post',
    data,
  })
}

export const getUserFeedbackWorkOrder = (data: RequestData) => {
  return request('getUserFeedbackWorkOrder', {
    method: 'post',
    data,
  })
}

export const getEventQuantity = (data: RequestData) => {
  return request('violationEventStatistics', {
    method: 'post',
    data,
  })
}
